// extracted by mini-css-extract-plugin
export default {"switcherContainer":"WeatherSwitcher_switcherContainer__9CpFz","switcherBtn":"WeatherSwitcher_switcherBtn__rIpTf"};